const RATING_VALUES = [
    1,
    2,
    3,
    4,
    5
];
export function diff(a, b) {
    return Object.fromEntries(Object.entries(b).filter(([key, val])=>key in a && a[key] !== val));
}
export function isObject(value) {
    return typeof value === 'object' && !Array.isArray(value) && value !== null;
}
export function isString(value) {
    return typeof value === 'string';
}
export function isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
export function isRating(value) {
    return typeof value === 'number' && RATING_VALUES.includes(value);
}

//# sourceMappingURL=utils.js.map